var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"t-btn-green",attrs:{"to":_vm.link}},[(!_vm.isMobile)?[_vm._v("\n    "+_vm._s(_vm.name)+"\n  ")]:[_c('svg',{attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M21 12L3 12M17 16L21 12L17 16ZM21 12L17 8L21 12Z","stroke":"#00b0bd","stroke-width":"1.68","stroke-linecap":"round","stroke-linejoin":"round"}})])]],2)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/templates/components/lk/btn-green/btn-green.vue?vue&type=template&id=108da2b7&
// module id = 1324
// module chunks = 0